import { Typography, BaseTable, TableBody, TableRow, TableCell, TableContainer, List, ListItem, Link } from "flux";
import { AdAssetFieldDisplayName } from "@adora/shared/features/ad-publishing/helpers";
export default function AdAssetDetailsTable<T extends string>({
  tableData
}: {
  tableData: Partial<Record<T, string | string[] | number | { type: "url"; value: string; displayText: string }>>;
}) {
  return (
    <TableContainer
      sx={{
        border: `1px solid`,
        borderColor: "lightgray",
        borderRadius: "10px",
        maxWidth: "1060px",
        marginBottom: "3rem"
      }}
    >
      <BaseTable size="small" sx={{ tableLayout: "fixed" }}>
        <TableBody>
          {Object.entries(tableData).map(([k, v], idx) => {
            return (
              <TableRow key={idx} sx={{ borderBottom: "1px solid", borderColor: "lightgray" }}>
                <TableCell width="20%">
                  <Typography variant="subtitle2">{AdAssetFieldDisplayName(k)}</Typography>
                </TableCell>
                <ListCell data={v as string | string[]} />
              </TableRow>
            );
          })}
        </TableBody>
      </BaseTable>
    </TableContainer>
  );
}

function ListCell({
  data
}: {
  data: string | string[] | number | { type: "url"; value: string; displayText: string };
}) {
  if (!data) return;
  let content;
  if (Array.isArray(data)) {
    if (data.length === 1) {
      content = <Typography variant="body3">{data[0]}</Typography>;
    } else if (data.length > 1) {
      content = (
        <List
          dense={true}
          disablePadding={true}
          sx={{ listStyleType: "disc", listStylePosition: "inside", marginLeft: "-16px" }}
        >
          {data.map((datum, index) => (
            <ListItem key={index} sx={{ display: "list-item" }}>
              <Typography variant="body3">{datum}</Typography>
            </ListItem>
          ))}
        </List>
      );
    }
  } else if (typeof data === "object" && "type" in data && data.type === "url") {
    const urlData = data as { type: "url"; value: string; displayText: string };
    content = (
      <Typography variant="body3">
        <Link href={urlData.value} target="_blank" rel="noopener noreferrer">
          {urlData.displayText}
        </Link>
      </Typography>
    );
  } else {
    content = <Typography variant="body3">{String(data)}</Typography>;
  }
  return <TableCell>{content}</TableCell>;
}
